import React from "react";
import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_shadowpath-next/artifacts/or3czz60_IMG_0211.png";

const Logo = ({ size = "md" }) => {
  const h = size === "lg" ? 104 : size === "sm" ? 44 : 58;
  return (
    <Link to="/" className="flex items-center group shrink-0" aria-label="Shadow Path Luxury Transport">
      <img
        src={LOGO_URL}
        alt="Shadow Path Luxury Transport"
        style={{ height: h }}
        className="w-auto object-contain transition-transform duration-300 group-hover:scale-[1.04] drop-shadow-[0_2px_10px_rgba(242,225,92,0.15)]"
      />
    </Link>
  );
};

export default Logo;
